module.exports = __webpack_public_path__ + "static/img/gift-box-dia-txt.eb24a1e.png";